import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';

import { trackV2 } from 'utils/analytics';

import styles from './styles.scss';

export function photoSrc(photo) {
  return photo.urls && photo.urls[Object.keys(photo.urls)[0]];
}

export default function Photos({ photos, analyticsData }) {
  if (photos.length === 0) {
    return null;
  }

  const maxPhotos = 4;
  const displayPhotos = photos.slice(0, maxPhotos);
  const overflowCount = photos.length - maxPhotos + 1;

  return (
    <div className={styles.container}>
      <h3>
        {photos.length}{' '}
        {I18n.t(
          `strava.activities.show_public.${
            photos.length > 1 ? 'photos' : 'photo'
          }`
        )}
      </h3>
      <ul className={styles.photosList}>
        {displayPhotos.map((photo) => (
          <li key={photo.unique_id}>
            <div
              className={styles.photoWrapper}
              onClick={() =>
                trackV2({ ...analyticsData, element: 'photo', action: 'click' })
              }
              onKeyDown={() =>
                trackV2({ ...analyticsData, element: 'photo', action: 'click' })
              }
              role="button"
              tabIndex="0"
            >
              <img src={photoSrc(photo)} alt={photo.caption} />
            </div>
          </li>
        ))}

        {overflowCount > 1 && (
          <li className={styles.overflow}>
            <div className={styles.overflowCount}>+{overflowCount}</div>
          </li>
        )}
      </ul>
    </div>
  );
}

Photos.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.object).isRequired,
  analyticsData: PropTypes.shape().isRequired
};
